import React from 'react';
import styled from '@emotion/styled';

interface Props {
  total: number;
  className?: string;
}

export default React.memo((props: Props) => {
  const { total, className } = props;
  return <StyledContainer className={className || ''}>{total && <span>{`$${total}`}</span>}</StyledContainer>;
});

const StyledContainer = styled.div`
  // padding-left: 0.5rem;
`;
